import type { IconData } from '@stacksjs/iconify-core'

export const warpSqueeze: IconData = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\" d=\"M15 24c0-6.361-5.994-10.224-9.51-11.943c-1.21-.591-1.625-2.115-.603-2.992C7.646 6.697 13.617 3 24 3s16.354 3.697 19.114 6.065c1.022.877.606 2.4-.604 2.992C38.995 13.776 33 17.639 33 24s5.995 10.224 9.51 11.943c1.21.592 1.626 2.115.604 2.992C40.354 41.303 34.384 45 24 45S7.646 41.303 4.887 38.935c-1.022-.877-.606-2.4.603-2.992C9.006 34.224 15 30.361 15 24\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default warpSqueeze
